module.exports = __webpack_public_path__ + "static/media/objects_09.828b0aa0.svg";